"use strict";

window.Components.Compound.CheckboxLabel = createReactClass({
  propTypes() {
    return {
      label: PropTypes.string.isRequired,
      labelClasses: PropTypes.string.isRequired,
      onChange: PropTypes.func,
      initChecked: PropTypes.bool,
      disabled: PropTypes.bool
    };
  },
  getDefaultProps() {
    return {
      initChecked: false
    };
  },
  getInitialState() {
    return {
      checked: this.props.initChecked
    };
  },
  checkboxClicked(event) {
    if (this.props.disabled) {
      return;
    }
    this.setState({
      checked: event.target.checked
    });
    if (this.props.onChange) {
      return this.props.onChange(event.target.checked);
    }
  },
  render() {
    const labelStyle = `clickable ${this.props.labelClasses}`;
    return /* @__PURE__ */React.createElement("label", {
      className: labelStyle
    }, /* @__PURE__ */React.createElement("input", {
      type: "checkbox",
      className: "Checkbox u-mr2x",
      onChange: this.checkboxClicked,
      checked: this.state.checked,
      disabled: this.props.disabled,
      ref: "checkbox"
    }), this.props.label);
  }
});